<template>
  <div>
    <b-row class="mb-3">
      <b-col md="6">
        <h5>
          <strong>DESCRIPCION DE LA RAM:</strong>
        </h5>
        <b-form-textarea
          v-model="form.descripcionRam"
          placeholder="Describir la RAM"
          rows="3"
          no-resize
        />
      </b-col>

      <b-col md="6">
        <h5>
          <strong>HISTORIA CLINICA RELEVANTE DEL PACIENTE:</strong>
        </h5>
        <b-form-textarea
          v-model="form.historiaClinica"
          placeholder="Historia clinica"
          rows="3"
          no-resize
        />
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col md="6">
        <b-form-group
          label="RAM desaparecio al reducir la dosis del medicamento?"
        >
          <b-form-radio-group
            v-model="form.ramDesaparecio"
            :options="yesNoOptions"
            stacked
          />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group
          label="RAM reaparecio al administrar de nuevo el medicamento?"
        >
          <b-form-radio-group
            v-model="form.ramReaparecio"
            :options="yesNoOptions"
            stacked
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col>
        <b-form-group label="Desenlace de la RAM">
          <b-form-radio-group
            v-model="form.desenlace"
            :options="desenlaceOptions"
            stacked
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col class="text-right">
        <b-button variant="primary" @click="onGuardarDatos">Guardar</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "CrearTarjetAmarilla",

  data() {
    return {
      form: {
        descripcionRam: "",
        historiaClinica: "",
        ramDesaparecio: null,
        ramReaparecio: null,
        desenlace: null,
      },
      yesNoOptions: [
        { value: "si", text: "Si" },
        { value: "no", text: "No" },
      ],
      desenlaceOptions: [
        { value: "mortal", text: "Mortal" },
        { value: "resuelto", text: "Recuperado / Resuelto" },
        { value: "recuperacion", text: "En recuperacion" },
        { value: "secuela", text: "Recuperado con secuela" },
        { value: "no_resuelto", text: "No recuperado / No resuelto" },
        { value: "desconocido", text: "Desconocido" },
      ],
    };
  },

  methods: {
    onGuardarDatos() {
      this.$emit("save", { ...this.form });
    },
  },
};
</script>
